(function () {
    "use strict";

    angular
        .module("app")
        .factory("GridUtil", ["$filter", gridUtil]);


    function gridUtil($filter) {

        function formatPercent(params, mask) {
            if (params && params.value) {
                // http://numeraljs.com/#format
                return numeral(params.value / 100).format(mask);
            }
            return "";
        }

        function formatCurrency(params, mask) {
            if (params && params.value) {
                // http://numeraljs.com/#format
                return numeral(params.value).format(mask);
            }
            return "";
        }

        function setRollbackData(obj) {
            obj.__rollbackData = angular.copy(obj);

            if (obj.__rollbackData.__rollbackData) {
                delete obj.__rollbackData.__rollbackData;
            }
        }

        function numericCellEditor() {
            this.allowDecimal = true;
        }

        numericCellEditor.prototype.init = function (params) {
            this.params = params;
            this.eInput = document.createElement("input");
            this.eInput.className = "ag-cell-edit-input";
            this.eInput.maxLength = "8";
            this.eInput.type = "text";

            if (params.charPress) {
                var number = parseInt(params.charPress);
                if (!isNaN(number))
                    this.eInput.value = params.charPress;
            } else {
                this.eInput.value = params.value;
            }

            //backspace, tab, up, down, left, right, enter, period, num pad period
            var allowedKeys = [8, 13, 37, 38, 39, 40, 46];

            if (this.allowDecimal === true) {
                allowedKeys.push(190);//period
                allowedKeys.push(110);//num pad period
            }

            //Ctrl + A, C, V, X, R, Z
            var allowedMetaKeys = [65, 86, 67, 88, 116, 82, 90];

            this.eInput.addEventListener("keydown", function (event) {

                var eventKey = event.key;

                //no spacebar
                if (eventKey === " ") {
                    eventKey = "x";
                    //just defaulting it to a value that isnt allowed
                }

                if (isNaN(eventKey)) {
                    var ctrlMeta = event.ctrlKey === true || event.metaKey === true;
                    //if ctrl isnt being pressed
                    if (!ctrlMeta) {
                        if (allowedKeys.indexOf(event.keyCode) === -1) {
                            event.preventDefault();
                        }
                        if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                            event.preventDefault();
                        }
                    }
                }
            });
        };

        numericCellEditor.prototype.getGui = function () {
            return this.eInput;
        };

        numericCellEditor.prototype.afterGuiAttached = function () {
            var value = this.eInput.value ? this.eInput.value.toString().length : "";

            this.eInput.value = this.eInput.value;

            if (!this.params.charPress) {
                this.eInput.setSelectionRange(0, value);
            } else {
                if (value !== "") {
                    this.eInput.setSelectionRange(value, value);
                }
            }

            this.eInput.focus();
        };

        numericCellEditor.prototype.isCancelBeforeStart = function () {
            return this.cancelBeforeStart;
        };

        numericCellEditor.prototype.getValue = function () {
            return this.eInput.value;
        };

        function intCellEditor() {
            numericCellEditor.call(this);

            this.allowDecimal = false;
        }

        intCellEditor.prototype = Object.create(numericCellEditor.prototype);

        Object.defineProperty(intCellEditor.prototype, "constructor", { value: intCellEditor, enumerable: false, writable: true });

        return {
            numericCellEditor: numericCellEditor,

            intCellEditor: intCellEditor,

            dateParse: function (params, date) {
                var format = date ? "MM/DD/YYYY" : "ll";
                if (params) {
                    var dt = typeof params.value !== "undefined" ? moment(params.value) : moment(params);
                    return dt.isValid() ? dt.local().format(format) : "";
                }
                return "";
            },

            dateParseNonLocal: function (params) {
                if (params) {
                    var dt = typeof params.value !== "undefined" ? moment(params.value) : moment(params);
                    return dt.isValid() ? dt.utc().format("ll") : "";
                }
                return "";
            },

            multiline: function (params) {
                if (params) {
                    var value = params.value || "";
                    return value.replace(/\n/g, "<br />");
                }
                return "";
            },

            check: function (params) {
                if (params) {
                    if (typeof params.value !== "undefined") {
                        return params.value && params.value !== null ? "✔" : "";
                    }
                    if (params === true)
                        return "✔";
                };
                return "";
            },

            /*
             * Renders number as a percentage with 0 decimal places.  EX: 0.2569 = 26%
             */
            percent: function (params) {
                return formatPercent(params, "0%");
            },

            /*
             * Renders number as a percentage with 1 decimal places.  EX: 0.2569 = 25.7%
             */
            percent1: function (params) {
                return formatPercent(params, "0.0%");
            },

            /*
             * Renders number as a percentage with 2 decimal places.  EX: 0.2569 = 25.69%
             */
            percent2: function (params) {
                return formatPercent(params, "0.00%");
            },
            
            /*
             * Renders number as currency with 0 decimal places.  EX: 1225.69 = $1,126
             */
            currency: function (params) {
                return formatCurrency(params, "($0,0)");
            },

            /*
             * Renders number as currency with 2 decimal places.  EX: 1225.69 = $1,125.69
             */
            currency2: function (params) {
                return formatCurrency(params, "($0,0.00)");
            },

            number: function (params) {
                return $filter("number")(params.value);
            },

            /*
             * Automatically adjusts all column widths based on headers and content.
             */
            autoSizeAll: function (gridOptions) {
                var allColumnIds = [];
                gridOptions.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
                gridOptions.columnApi.autoSizeColumns(allColumnIds);
            },

            setSort: function (columnDefs, sortField, direction) {
                if (sortField) {
                    angular.forEach(columnDefs, function (col) {
                        if (col.field === sortField) {
                            col.sort = direction;
                        }
                    });
                }
            },

            /*
             Calculates a row's height - to be used in conjunction with gridOptions.getRowHeight callback.
              Example:
                  gridOptions = {
                    onColumnVisible: function (e) {
                        gridOptions.api.resetRowHeights();
                    }
                    getRowHeight: function (params) {
                        return GridUtil.getRowHeight(params, $scope.columnDefs, 30, 76, 200);
                    }
                  }
            */
            getRowHeight: function (params, columnDefs, defaultRowHeight, imageRowHeight, maxRowHeight) {
                var rowHeight = defaultRowHeight;
                maxRowHeight = maxRowHeight || 200;
                imageRowHeight = imageRowHeight || 76;

                var lineCount = 0;

                angular.forEach(columnDefs, function (colDef) {
                    if (colDef.hide === true)
                        return;

                    if (colDef.cellRendererName === "multiline") {
                        var value = params.data[colDef.field];

                        if (value) {
                            var match = value.match(/\n/g);
                            if (match) {
                                var newLineCount = match.length + 1;
                                lineCount = Math.max(lineCount, newLineCount);
                            }
                        }
                    }
                    else if (colDef.cellRendererName === "image") {
                        rowHeight = imageRowHeight;
                    }
                });

                params.node.lineCount = lineCount;

                if (params.node.lineCount > 0) {
                    return Math.min(maxRowHeight, Math.max(rowHeight, (params.node.lineCount * 14 * 1.4) + 10));
                }

                return rowHeight;
            },

            enableRollback: function (arrayOfData) {
                if (!angular.isArray(arrayOfData)) return;

                angular.forEach(arrayOfData, function (r) {
                    setRollbackData(r);
                });
            },

            updateRollbackData: function (obj) {
                setRollbackData(obj);
            },

            rollback: function (obj, gridOptions) {
                var rollback = obj.__rollbackData;

                if (rollback) {
                    for (var p in rollback) {
                        if (obj.hasOwnProperty(p)) {
                            obj[p] = rollback[p];
                        }
                    }
                }

                if (gridOptions) {
                    gridOptions.api.updateRowData({
                        update: [obj]
                    });

                    gridOptions.api.refreshCells({ force: true });
                }
            }
        };
    };
})();
